import MoreVertIcon from '@mui/icons-material/MoreVert';
import { deleteDoc, doc } from 'firebase/firestore';
import { useContext, useState } from 'react';
import db from '../firebase';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { AuthContext } from '../AuthContext';
import { useRef } from 'react';
import { FormatTimePassedUtc, handleDecreaseCommentCount } from '../newComponents/GeneralClasses';

const CommentContent = ({username,profilepic,postID,commenttext,timestamp,commentID,useremail}) => {
    const [menuoptions,setMenuoptions]=useState(false);
    const [owner,setOwner]=useState(false);
    const {user_email}= useContext(AuthContext);
    const navigate = useNavigate();
    const ref = useRef();
    const commentmenu = useRef();

    useEffect(()=>{
        if(useremail === user_email){
            setOwner(true);
        }else{
            setOwner(false);
        }
    },[useremail,user_email]);

    useEffect(()=>{
        ref.current?.scrollIntoView({behavior:"smooth", block: "nearest"});
    },[commenttext]);

    useEffect(()=>{
        const closeCoommentmenu=(e)=>{
            if(!commentmenu.current.contains(e.target)){
                    setMenuoptions(false);
            }
        }
        document.addEventListener('mousedown',closeCoommentmenu);
        return () => {
        document.removeEventListener('mousedown',closeCoommentmenu);
        }
    },[]);

    const deleteCommentDoc =async()=>{
            try{
                const doc_Ref = doc(db,"blog comments",commentID);
                await deleteDoc(doc_Ref);
                handleDecreaseCommentCount(postID);
            }catch(error){
      
            }
    };
    const report=()=>{
        navigate("/contact");
    };

    return ( 
        <div ref={ref} className="commentcontentdisplay">

               {
                profilepic && profilepic !== null ? <img id="blogProfile" src={profilepic} alt="" />
                :
                <svg
                viewBox="0 0 24 24"
                fill="#812072"
                id='blogProfilesvg'>
                <path fill="none" d="M0 0h24v24H0z" />
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm0 14c-2.03 0-4.43-.82-6.14-2.88a9.947 9.947 0 0112.28 0C16.43 19.18 14.03 20 12 20z" />
                </svg>
                }

                <div className="commentcontentbody" style={{display:"flex",flexDirection:"column",alignItems:"center"}}>
                    <div className="ccbtop" style={{display:"flex",flexDirection:"row",alignItems:"center",justifyContent:"space-between",width:"100%"}}>
                        <div style={{
                            display:"flex",
                            flexDirection:"row",
                            alignItems:"center",
                            justifyContent:"center",
                            flexWrap:"wrap",
                            width:"80%",
                            gap:"10px"
                            }}>
                            {username && <p>{username}</p>}
                            {timestamp && <p>{FormatTimePassedUtc(timestamp)}</p>}
                        </div>

                        <div className="ccbmenu" style={{position:"relative"}} ref={commentmenu}>
                           
                                <div style={{cursor:"pointer"}}
                                    onClick={()=>setMenuoptions(prev => !prev)}>
                                    <MoreVertIcon/>
                                </div>
                            

                            {menuoptions && 
                                <div className="ccbmenuoption">
                                   {owner && <button onClick={() => deleteCommentDoc()} >Delete</button>} 
                                    <button onClick={() => report()} style={{color:"red"}}>Report</button>
                                </div>
                            }
                        </div>
                    </div>

                    {commenttext && 
                    <pre style={{width:"100%",whiteSpace:"pre-wrap"}}>
                        {commenttext}
                    </pre>
                    }
                </div>
        </div>
     );
}
export default CommentContent;